export const DEFAULT_MAX_FILE_SIZE = 1048576 * 10 //10MB
